export default __webpack_public_path__ + "static/game-theory-mobile-hold-1159443ed7d39d73ebdf04daec21a01f.svg";